<template>
    <v-dialog
        v-if="changeInventoryDialog"
        v-model="changeInventoryDialog"
        persistent
        width="600px"
    >
        <v-form ref="changeInventoryForm">
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon dark class="mr-2">filter_1</v-icon>Change
                    Inventory
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-toolbar class="py-2" outlined flat>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-toolbar-title
                                    class="title pr-2"
                                    v-on="on"
                                >
                                    {{
                                        growthTask
                                            ? growthTask.plant.name
                                            : ""
                                    }}
                                    <div
                                        class="
                                            mt-n1
                                            grey--text
                                            text--darken-1
                                            caption
                                        "
                                        v-if="growthTask"
                                    >
                                        {{
                                            (growthTask
                                                ? growthTask.growthStartDate
                                                : "1970-01-01")
                                                | moment("YYYY-[W]WW")
                                        }}
                                    </div>
                                </v-toolbar-title>
                            </template>
                            <span>{{
                                growthTask ? growthTask.plant.name : ""
                            }}</span>
                        </v-tooltip>

                        <v-spacer />
                        <v-icon :color="taskColor" class="mr-1">eco</v-icon>
                        <span :class="taskColor + `--text headline`">{{
                            growthTask ? growthTask.totalInventory : 0
                        }}</span>
                    </v-toolbar>

                    <!-- change quantity -->
                    <v-list-item class="align-center mt-5 pl-0">
                        <v-list-item-icon>
                            <v-btn-toggle
                                v-model="
                                    changeInventoryData.toggleChangeInventoryButtonGroup
                                "
                                class="ml-5 mr-6"
                                mandatory
                            >
                                <v-btn active-class="primary--text">
                                    <v-icon>add</v-icon>
                                </v-btn>
                                <v-btn active-class="primary--text">
                                    <v-icon>remove</v-icon>
                                </v-btn>
                            </v-btn-toggle>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-text-field
                                v-if="
                                    changeInventoryData.toggleChangeInventoryButtonGroup ===
                                        0
                                "
                                v-model="changeInventoryData.changeQuantity"
                                min="1"
                                type="number"
                                label="Change Quantity *"
                                outlined
                                class="subtitle-2"
                            ></v-text-field>
                            <v-text-field
                                v-else
                                v-model="changeInventoryData.changeQuantity"
                                :rules="[
                                    rules.required,
                                    rules.maxNumber(
                                        growthTask
                                            ? growthTask.totalInventory
                                            : 1
                                    )
                                ]"
                                min="1"
                                type="number"
                                label="Change Quantity *"
                                outlined
                                class="subtitle-2"
                            ></v-text-field>
                        </v-list-item-content>
                    </v-list-item>

                    <!-- comment -->
                    <v-row class="ma-0">
                        <v-col cols="12">
                            <!-- change reasons -->
                            <v-autocomplete
                                v-model="
                                    changeInventoryData.inventoryChangeReasonTag_Id
                                "
                                :items="manualReasons"
                                item-text="node.tag"
                                item-value="node.id"
                                :loading="loadingChangeReasons"
                                label="Change Reason"
                                class="subtitle-2"
                                outlined
                            >
                                <template
                                    v-if="
                                        hasPermission(
                                            'add_inventorychangereasontag'
                                        )
                                    "
                                    v-slot:append-outer
                                >
                                    <v-btn text small tabindex="-1">
                                        <v-icon
                                            color="grey"
                                            @click="
                                                addInventoryManualReasonTag
                                            "
                                            tabindex="-1"
                                            >add</v-icon
                                        >
                                    </v-btn>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="changeInventoryData.comment"
                                label="Note"
                                outlined
                                class="subtitle-2"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="mr-5 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="$emit('closeInventoryDialog')"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!hasPermission('change_growthtask')"
                        outlined
                        rounded
                        color="primary"
                        :loading="isSaving"
                        @click="validateInventoryChangeForm"
                        >Change</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import helper from "@/utils/helper.js";
    export default {
        name : "GrowthTaskInventoryUpdateDialog",
        props : ["changeInventoryDialog","growthTask","isSaving","taskColor","changeInventoryData","rules","manualReasons","loadingChangeReasons", "addInventoryManualReasonTag"],
        data(){
            return {

            }
        },
        methods : {
            validateInventoryChangeForm(){
                this.$emit('InventoryChangeFormValidation', this.$refs.changeInventoryForm.validate())
            }
        },
        created() {
            this.hasPermission = helper.hasPermission;
        },
    }
</script>